<div class="card-scoreboard_info font-small">
    @if (swapLiveBadge) {
        <ng-container *ngTemplateOutlet="iconTimeTemplate; context: { iconName: 'sports-video-active-marquee', iconHeight: '16' }" />
        @if (event.live) {
            <span class="live-badge">{{ sitecore.event.Live }}</span>
        }
    } @else {
        @if (event.live) {
            <span class="live-badge">{{ sitecore.event.Live }}</span>
        }
        <ng-container *ngTemplateOutlet="iconTimeTemplate; context: { iconName: 'sports-video-badge-b', iconHeight: '11' }" />
    }
</div>

<ng-template #iconTimeTemplate let-iconName="iconName" let-iconHeight="iconHeight">
    @if (isVideoStreamAvailable() && !showStream) {
        <span class="icon-badge-alignment" [class.video-badge-live]="event.live"
            ><vn-icon height="{{ iconHeight }}" name="{{ iconName }}" width="16"
        /></span>
    }
    <ms-event-timer [live]="event.live" [start]="event.startDate" [scoreboard]="event.scoreboard" />
</ng-template>
